@if (open()) {
  <div class="popover is-draft" [class.is-drawing]="drawing()" #popoverEl [style.left.px]="left()" [style.top.px]="top()">
    <div class="pop-head">
      <div class="h-top">
        <span class="num-pill">#{{ markerNumber() }}</span>
        <span class="h-url">New feedback</span>
      </div>
      <div class="h-element">Tell us what you noticed</div>
      <button class="close-x" type="button" aria-label="Close" [disabled]="drawing()" (click)="cancel.emit()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12" /></svg>
      </button>
    </div>

    <div class="pop-scroll">
      @if (!drawing()) {
        <div class="pop-section">
          <div class="label">Element <span class="req" aria-hidden="true">*</span></div>
          <input
            class="pop-input"
            type="text"
            required
            aria-required="true"
            placeholder="e.g. Hero headline, Primary CTA, Footer links"
            [value]="element()"
            (input)="element.set($any($event.target).value)"
          />
        </div>

        <div class="pop-section">
          <div class="label">Observation <span class="req" aria-hidden="true">*</span></div>
          <textarea
            class="pop-textarea"
            required
            aria-required="true"
            placeholder="What should change and why?"
            [value]="observation()"
            (input)="observation.set($any($event.target).value)"
          ></textarea>
        </div>
      }

      @if (!drawing()) {
        <div class="asset-row">
          <fb-asset-add menuAlign="end" [disabled]="submitting()" (added)="onAssetsAdded($event)" />
        </div>
      }

      <!-- When a video was recorded the screenshot is hidden from view but kept in
           the DOM (canvas still painted with the poster) for later upload. -->
      <div class="pop-section" [class.is-hidden]="videoUrl() || screenshotSkipped()">
        <div class="label">Screenshot</div>
        @if (captureWarning(); as warning) {
          <div class="capture-warn" role="status">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg>
            <span>{{ warning }}</span>
          </div>
          <label class="upload-shot">
            <input type="file" accept="image/*" (change)="onUploadScreenshot($event)" hidden />
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" /></svg>
            <span>{{ manualScreenshotUrl() ? 'Replace with another upload' : 'Upload a screenshot' }}</span>
          </label>
        }
        <div class="pop-shot" [class.is-drawing]="drawing()" [class.is-empty]="!hasScreenshot()">
          @if (hasScreenshot()) {
            <div class="shot-tools">
              <button
                class="shot-tool"
                type="button"
                [class.is-active]="drawing()"
                [title]="drawing() ? 'Finish drawing' : 'Annotate screenshot'"
                (click)="toggleDraw()"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9" /><path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4 12.5-12.5z" /></svg>
                <span>{{ drawing() ? 'Done drawing' : 'Draw' }}</span>
              </button>
            </div>
          }
          <canvas
            #shotCanvas
            class="shot-canvas"
            [class.is-hidden]="!hasScreenshot()"
            (pointerdown)="onCanvasPointerDown($event)"
            (pointermove)="onCanvasPointerMove($event)"
            (pointerup)="onCanvasPointerUp()"
            (pointerleave)="onCanvasPointerUp()"
          ></canvas>
          @if (!hasScreenshot()) {
            <div class="shot-empty">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><path d="m21 15-5-5L5 21" /></svg>
              <span>No screenshot yet — upload one above.</span>
            </div>
          } @else {
            <div class="shot-tag">pin-{{ markerNumber() }}.png</div>
          }
        </div>
      </div>

      @if (videoUrl()) {
        <div class="pop-section">
          <div class="label">Recording</div>
          <video class="shot-video" [src]="videoUrl()" controls playsinline preload="metadata"></video>
        </div>
      }

      @if (assets().length && !drawing()) {
        <div class="pop-section">
          <div class="label">Assets <span class="asset-count">{{ assets().length }}</span></div>
          <fb-asset-list [assets]="assets()" [disabled]="submitting()" (remove)="onAssetRemoved($event)" />
        </div>
      }
    </div>

    <div class="pop-foot">
      @if (submitting()) {
        <fb-loading-bar class="pop-foot-loading" [height]="3" [rounded]="false" />
      }
      <div class="pop-foot-actions">
        <button class="btn" type="button" [disabled]="drawing() || submitting()" (click)="cancel.emit()">Cancel</button>
        <button
          class="btn primary"
          type="button"
          [disabled]="!canSubmit() || drawing() || submitting()"
          (click)="onSubmit()"
        >
          Submit feedback
        </button>
      </div>
    </div>
  </div>
}
